import { NavigateFunction } from "react-router-dom";
import { ROUTES } from 'constants/routing'

export function logout(navigate: NavigateFunction, cognito: { signOut: () => void }) {
  navigate(ROUTES.Login.path);
  cognito.signOut();
}
